import { render, staticRenderFns } from "./softwareList.vue?vue&type=template&id=1b26bd06&"
import script from "./softwareList.vue?vue&type=script&lang=js&"
export * from "./softwareList.vue?vue&type=script&lang=js&"
import style0 from "./softwareList.vue?vue&type=style&index=0&id=1b26bd06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports